import {
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { TimeInputField } from '@/domain/termine/components/TimeInput/TimeInputField';
import { FormValues } from '@/domain/termine/shared/types/CreateTermineInput';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export function TimeInputFormField({
  name,
  form,
}: {
  name: 'beginn' | 'ende';
  form: UseFormReturn<FormValues>;
}) {
  const { t } = useTranslation();

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {name === 'ende'
              ? t('domain.termine.sheet.fields.bis')
              : t('domain.termine.sheet.fields.von')}
          </FormLabel>
          <TimeInputField
            className="w-20"
            {...field}
            onChange={field.onChange}
          />
          <FormMessage className="w-fit" />
        </FormItem>
      )}
    />
  );
}
